import React from 'react';
import './ResellersPartnerPortal.scss';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';

/**
 * Renders resellers partner portal module
 * @param {string} title
 * @param {string} ctaText
 * @param {string} ctaLink
 * @returns {JSX.Element}
 * @constructor
 */
const ResellersPartnerPortal = ({ title, ctaText, ctaLink }) => (
  <div className="c-resellers-partner-portal background-color-gray">
    <div className="c-resellers-partner-portal__inner module-background-color-blue">
      <div className="c-resellers-partner-portal__content">
        <div className="c-resellers-partner-portal__title h2-roobert color-gray">
          <h2>{title}</h2>
        </div>
        <div className="c-resellers-partner-portal__cta">
          <CTAButton
            type={'secondary'}
            link={ctaLink}
            text={ctaText}
            target={'_blank'}
            additionalClasses={'cta color-white'}
          />
        </div>
      </div>
    </div>
  </div>
);

export default ResellersPartnerPortal;
